import { useCallback, useMemo } from 'react';
import { formatDate }              from 'Utils';
import { Event, EventTicket } from 'Domain/Models';

export const useGetEventDateOptions = (event: Event) => {

  const getEventKey = useCallback((datum: Pick<EventTicket, 'date' | 'startTime' | 'endTime'>) => `${datum.date}|${datum.startTime}|${datum.endTime}`, []);

  const revertDatumByEventKey = useCallback((key?: string) => {
    if(!key) {
      return null;
    }
    const [ date, startTime, endTime ] = key.split('|');
    return { date: new Date(date), startTime, endTime };
  }, []);

  const options = useMemo((): {value: string, label: string}[] => {
    if (!event) {
      return [];
    }

    if(event.type === 'start_end') {
      if(!event.startAt || !event.endAt) {
        return [];
      }
      const start = event.startAt;
      const end = event.endAt;

      const startTime = event.startStartTime || '00:00';
      const endTime = event.endEndTime || '23:59';

      const _dates = [];
      let currentDate = new Date(start);
      while(currentDate.getTime() <= end.getTime()) {
        _dates.push({
          value: getEventKey({ date: currentDate, startTime, endTime }),
          label: `${formatDate(currentDate)} | Von: ${startTime}  Bis: ${endTime}`,
        });
        currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
      }
      return _dates;
    }

    return event.dates.map((datum) => ({
      value: getEventKey({ date: datum.date, startTime: datum.start, endTime: datum.end }),
      label: `${formatDate(datum.date)} | Von: ${datum.start}  Bis: ${datum.end}`,
    })) || [];
  }, [ event ]);

  return { getEventKey, revertDatumByEventKey, options };
}
